// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import 'babel-polyfill';
import MintUI from 'mint-ui';
import axios from 'axios';
import 'mint-ui/lib/style.css';
import Vuex from 'vuex';

Vue.use(Vuex)
Vue.config.productionTip = false
Vue.use(MintUI)
Vue.prototype.$ajax = axios
// axios.defaults.baseURL = 'https://qagw.qdingnet.com/qding-hk';
// axios.defaults.headers.post['saas_sessionId_online'] = "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ7XCJhY2NvdW50SWRcIjpcIjIwMTkwNzE5MTExODUzNTkxZWVcIixcImxvZ2luVHlwZVwiOlwiYXBwXCIsXCJ0ZW5lbWVudElkXCI6XCIyMDE5MDcxOTEwMzU0MDc1MjI4XCIsXCJ1c2VyaWRcIjpcIjE1MjQzMjEwMDA0XCIsXCJ1c2VybmFtZVwiOlwi54aK54yrMDRcIn0iLCJqdGkiOiJkMGUwODhkNS0zYWZiLTQ1OGMtYWU3NC05MjQ1MWU4YWVkYzAiLCJpYXQiOjE1NjQxMzk5Nzd9.0ymB-ieHbWPDSXwh0iWsbWnszCQjh0LOn-us15048gU";
// axios.defaults.headers.post['qdVersion'] ='6.0.1';
//axios.defaults.baseURL = 'https://hkapi.qdingnet.com/qding-hk'; //线上环境
//  axios.defaults.baseURL = 'https://qahkapi.qdingnet.com/qding-hk'; //qa环境
//axios.defaults.baseURL = 'https://qd.qdingnet.com/qds-live-admin-web';
// axios.defaults.headers = {'Content-Type':'application/x-www-form-urlencoded', 'qdSource':'h5'}
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.post['qdSource'] = 'h5';


function getcookie(name){
    let cookieb='';　　
    //检查这个cookie是否存在，不存在就为 -1
    let c_start = document.cookie.indexOf(name + "=")
    if (c_start != -1) {
        //获取cookie值的开始位置
        c_start = c_start + name.length + 1;
        
        //通过";"号是否存在来判断结束位置
        let c_end = document.cookie.indexOf(";", c_start);

        if (c_end == -1){
            c_end = document.cookie.length;
        }
        //通过substring()得到了值
        cookieb = unescape(document.cookie.substring(c_start, c_end))
        cookieb=Base64.decode(cookieb)
        cookieb= JSON.parse(cookieb);
        
    }
    axios.defaults.headers.post['qdVersion'] = (cookieb.qdVersion?cookieb.qdVersion:'');
    if(cookieb.saas_sessionId_online){
      // axios.defaults.baseURL = 'https://qagw.qdingnet.com/qding-hk';//qa环境
      axios.defaults.headers.post['saas_sessionId_online'] = (cookieb.saas_sessionId_online);
      axios.defaults.baseURL = 'https://gw.firstpm.com.cn/qding-hk';//线上环境
    }
    if(cookieb.userToken){
      // axios.defaults.baseURL = 'https://qahkapi.qdingnet.com/qding-hk';//qa环境
      axios.defaults.baseURL = 'https://hkapi.firstpm.com.cn/qding-hk';//线上环境
    }　　　
}
 getcookie('X');
// document.documentElement.style.fontSize = document.documentElement.clientWidth/6.4 + 'px';
//   window.onresize = function(){
//      document.documentElement.style.fontSize = document.documentElement.clientWidth/6.4 + 'px'}
/* eslint-disable no-new */

function setupWebViewJavascriptBridge(callback) {
  if (window.WebViewJavascriptBridge) { return callback(WebViewJavascriptBridge); }
  if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }
  window.WVJBCallbacks = [callback];
  var WVJBIframe = document.createElement('iframe');
  WVJBIframe.style.display = 'none';
  WVJBIframe.src = 'https://__bridge_loaded__';
  document.documentElement.appendChild(WVJBIframe);
  setTimeout(function() { document.documentElement.removeChild(WVJBIframe) }, 0)
}

setupWebViewJavascriptBridge(function(bridge) {
  initVueApp();
  // var uniqueId = 1
  // function log(message, data) {
  // var log = document.getElementById('log')
  // var el = document.createElement('div')
  // el.className = 'logLine'
  // el.innerHTML = uniqueId++ + '. ' + message + ':<br/>' + JSON.stringify(data)
  // if (log.children.length) { log.insertBefore(el, log.children[0]) }
  // else { log.appendChild(el) }
  // }
  
})

function connectWebViewJavascriptBridge(callback) {
  if (window.WebViewJavascriptBridge) {
      callback(WebViewJavascriptBridge)
  } else {
      document.addEventListener(
        'WebViewJavascriptBridgeReady',
        function() {
        callback(WebViewJavascriptBridge)
        },
        false
        );
  }
}

connectWebViewJavascriptBridge(function(bridge) {
  initVueApp();
 bridge.init(function(message, responseCallback) {
     console.log('JS got a message', message);
     var data = {
     'Javascript Responds': 'Wee!'
     };
     console.log('JS responding with', data);
     responseCallback(data);
     });
 })

function initVueApp() {}
  new Vue({
    el: '#app',
    router,
    axios,
    components: { App },
    template: '<App/>'
  })
 


// WEBPACK FOOTER //
// ./src/main.js